module.exports = __webpack_public_path__ + "static/media/card-comingsoon.9c90416b.png";